import { api } from "@/_store/api-client";
import {
  IGetFullMonitoringRequest, IGetFullMonitoringResponse,
  IGetMonitoringRequest,
  IGetMonitoringResponse,
  IGetShortMonitoringRequest,
  IGetShortMonitoringResponse
} from "./contracts";

export const monitoringApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createMonitoringChecking: builder.mutation<IGetMonitoringResponse, IGetMonitoringRequest>({
      query: (requestBody) => ({
        url: "/api/v1/inspections/",
        method: "POST",
        body: requestBody
      }),
      invalidatesTags: ["MonitoringChecking"],
    }),
    getShortMonitoringInfo: builder.query<IGetShortMonitoringResponse, IGetShortMonitoringRequest>({
      query: ({ inn }) => ({
        url: "/api/v1/inspections/short/",
        method: "GET",
        params: { inn }
      }),
      providesTags: ["ShortMonitoringInfo"],
      keepUnusedDataFor: 0,
    }),
    getFullMonitoringInfo: builder.query<IGetFullMonitoringResponse, IGetFullMonitoringRequest>({
      query: ({ id }) => ({
        url: `/api/v1/inspections/${id}/`,
        method: "GET",
      }),
      providesTags: ["FullMonitoringInfo"],
      keepUnusedDataFor: 0,
    })
  }),
  overrideExisting: false,
});

export const {
  useCreateMonitoringCheckingMutation,
  useLazyGetShortMonitoringInfoQuery,
  useGetFullMonitoringInfoQuery
} = monitoringApi;
